module.exports = __webpack_public_path__ + "static/media/photo-icon2.d4e73bde.svg";